import { render, staticRenderFns } from "./pdf-button.component.vue?vue&type=template&id=3d64f324&scoped=true"
import script from "./pdf-button.component.vue?vue&type=script&lang=js"
export * from "./pdf-button.component.vue?vue&type=script&lang=js"
import style0 from "./pdf-button.component.vue?vue&type=style&index=0&id=3d64f324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64f324",
  null
  
)

export default component.exports